import { render } from "./GetUserActivity.vue?vue&type=template&id=2cd566c6&scoped=true"
import script from "./GetUserActivity.vue?vue&type=script&lang=js"
export * from "./GetUserActivity.vue?vue&type=script&lang=js"

import "./GetUserActivity.vue?vue&type=style&index=0&id=2cd566c6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cd566c6"]])

export default __exports__